import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { ITelemetry } from '@msdyn365-commerce/telemetry-internal';
import { useEffect, useRef } from 'react';
import { useMappingService, useTrackingService } from './serviceHooks';

export const useProductViewTracker = (
    relewiseProductId: string | undefined,
    primarySizeVariantRelewiseId: string | undefined,
    request: IRequestContext,
    telemetry: ITelemetry
) => {
    const lastTrackedVariantRef = useRef<string | undefined>();
    const relewiseTrackingService = useTrackingService(request, telemetry);
    const relewiseMappingService = useMappingService(request, telemetry);

    useEffect(() => {
        if (typeof window === 'undefined' || !relewiseProductId || !primarySizeVariantRelewiseId) {
            return;
        }

        if (primarySizeVariantRelewiseId !== lastTrackedVariantRef.current) {
            relewiseTrackingService.trackProductView(relewiseProductId, primarySizeVariantRelewiseId);
            lastTrackedVariantRef.current = primarySizeVariantRelewiseId;
        }
    }, [relewiseProductId, primarySizeVariantRelewiseId, relewiseTrackingService, relewiseMappingService]);
};

// DEPRECATED - Still used in old buybox
// TODO: delete this hook when old buybox is no longer in use
export const useOldProductViewTracker = (
    itemId: string | undefined,
    defaultSizeValue: string | undefined,
    request: IRequestContext,
    telemetry: ITelemetry
) => {
    const lastTrackedVariantRef = useRef<string | undefined>();
    const relewiseTrackingService = useTrackingService(request, telemetry);
    const relewiseMappingService = useMappingService(request, telemetry);
    const search = typeof window === 'undefined' ? undefined : window.location.search;

    useEffect(() => {
        if (typeof window === 'undefined' || !itemId) {
            return;
        }

        const params = new URLSearchParams(search);
        const color = params.get('color');
        const size = params.get('size') ?? defaultSizeValue;
        const hasVariant = !!color && !!size;

        if (hasVariant) {
            const relewiseVariantId = relewiseMappingService.mapProductDimensionsToRelewiseVariantId(itemId, color, size);
            if (relewiseVariantId !== lastTrackedVariantRef.current) {
                relewiseTrackingService.trackProductView(relewiseMappingService.prefixId(itemId), relewiseVariantId);
            }
            lastTrackedVariantRef.current = relewiseVariantId;
        }
    }, [itemId, search, defaultSizeValue, relewiseTrackingService, relewiseMappingService]);
};
